import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m19.451 5.528-1.533 1.863q.313.25.54.545l1.925-.721c.75-.281 1.07-1.17.669-1.864a1.29 1.29 0 0 0-1.307-.628 1.3 1.3 0 0 1-.294.805"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M16.389 6.508q.397.155.795.388c.266.153.514.317.734.495l1.533-1.863a1.297 1.297 0 1 0-2.216-1.28z"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M15.647 6.313q.368.049.742.194l.846-2.258c.108-.29.308-.513.55-.657a1.29 1.29 0 0 0-1.197-.818c-.802 0-1.411.72-1.28 1.51zM18.643 10.39l-1.281-.74M12.49 9.048l1.263.729"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m18.644 10.39 2.582-1.353-1.148 3.001M4.606 8.514A2.297 2.297 0 0 1 6.87 5.837h.008a2.297 2.297 0 0 1 4.577 0h.008c.939 0 1.745.563 2.102 1.37"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M18.305 11.079c1.269-2.197.344-3.338-1.12-4.183-1.466-.846-2.916-1.077-4.184 1.12-.563.975-1.146 2.525-1.493 4.022h6.16c.25-.338.466-.662.637-.959M9.472 11.08c-1.055 1.056-2.867.956-2.867.956s-.1-1.812.956-2.868 2.867-.955 2.867-.955.1 1.811-.956 2.867"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5.644 9.168c1.056 1.056.956 2.868.956 2.868s-1.812.1-2.867-.956c-1.056-1.056-.956-2.867-.956-2.867s1.812-.1 2.867.955"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.603 18.929A3.83 3.83 0 0 1 2.774 15.1v-3.063h18.452v3.063a3.83 3.83 0 0 1-3.828 3.828H11.4"
    />
  </svg>
);
export const SaladIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
